
import { useNavigate } from "react-router-dom";


const BASE_URL = process.env.REACT_APP_BASE_URL;

const DeleteCMLModal = ({
  deleteId,
  setDeleteId,
  type,
  fetchCourseContent,
}) => {
  const navigate = useNavigate();

  // When modal opens, stop page scroll
  // useEffect(() => {
  //   if (deleteId) {
  //     document.body.style.overflow = "hidden";
  //   } else {
  //     document.body.style.overflow = "auto";
  //   }

  //   // cleanup
  //   return () => {
  //     document.body.style.overflow = "auto";
  //   };
  // }, [deleteId]);

  // Function to delete based on type
  const handleDelete = async (id) => {
    try {
      const token = localStorage.getItem("access_token");

      // Choose API link based on type
      let url = "";
      if (type === "course") {
        url = `${BASE_URL}/courses/${id}/delete/`;
      } else if (type === "module") {
        url = `${BASE_URL}/courses/module/${id}/delete/`;
      
      }
      else if(type==='resource')
      {
         url = `${BASE_URL}/courses/${id}/lesson/delete/`;
      }
       else {
        url = `${BASE_URL}/courses/course/module/lesson/${id}/delete/`;
      }

      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
      });

      if (!response.ok) {
        throw new Error("Failed to delete");
      }

      alert(`${type.toUpperCase()} Deleted Successfully`);
       setDeleteId(null);
      if (type === "course") {
        navigate("/teacher/course");
      } else {
        fetchCourseContent(); // refresh modules/lessons list
      }

      // setDeleteId(null);

    } catch (error) {
      console.error("Delete error:", error);
    }
  };

  // Close modal when clicking outside
  const handleModalClick = (e) => {
    if (e.target === e.currentTarget) {
      setDeleteId(null);
    }
  };

  return (
  <div>
  {deleteId && (
    <div
      onClick={handleModalClick}
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-[1000] p-4"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white w-full max-w-md rounded-2xl shadow-xl overflow-hidden"
      >
        {/* Modal Header */}
        <div className="p-6 border-b border-gray-100">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-red-50 rounded-lg flex items-center justify-center">
              <svg className="w-5 h-5 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900">
                Delete {type?.toUpperCase()}
              </h3>
              <p className="text-sm text-gray-500 mt-0.5">
                This action cannot be undone
              </p>
            </div>
          </div>
        </div>

        {/* Modal Content */}
        <div className="p-6">
          <div className="text-center">
            <div className="mx-auto w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mb-4">
              <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.998-.833-2.732 0L4.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            <h4 className="text-lg font-semibold text-gray-900 mb-2">
              Are you sure you want to delete this {type}?
            </h4>
            <p className="text-gray-600">
              This action cannot be undone. All data will be permanently removed.
            </p>
          </div>
        </div>

        {/* Modal Footer */}
        <div className="px-6 py-4 bg-gray-50/50 border-t border-gray-100">
          <div className="flex items-center justify-end gap-3">
            <button
              type="button"
              onClick={() => setDeleteId(null)}
              className="px-5 py-2.5 text-gray-700 font-medium rounded-xl hover:bg-gray-100 transition-colors"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={() => handleDelete(deleteId)}
              className="px-5 py-2.5 bg-red-500 text-white font-medium rounded-xl hover:bg-red-600 transition-colors flex items-center gap-2"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  )}
</div>

  );
};

export default DeleteCMLModal;
